import request from '@/utils/request';

export const login = (params) => request({
  url: '/shuyutong/plugInLoginVerification',
  customIP: setingDefault.loginIP,
  method: 'post',
  params,
});

// 查询token是否失效
export const isInspectionToken = (params) => request({
  url: '/shuyutong/plugInTokenVerification',
  customIP: setingDefault.loginIP,
  method: 'post',
  params,
});